import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Employer } from '../../../state/types';

type Props = {
  employer: Employer;
};

export const EmptyState: FC<Props> = ({ employer }) => {
  const t = useTranslations('people.details.credits.emptyState');

  return (
    <Box mt='s' data-testid='empty-state-no-user-credits' textAlign='center'>
      <Typography variant='h1' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light'>
        {t('description', { name: `${employer.firstName || ''} ${employer.lastName || ''}` })}
      </Typography>
    </Box>
  );
};
